import { openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-sm btn-blue ms-6 max-h-34 btn-min-w line-height",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveOptions()))
  }, " Save & Close "))
}